module.exports = __webpack_public_path__ + "static/img/zxd@2x.e7b7b41e.png";